import React from 'react';

function SlicedTableColumn({ text, onClick, length }) {
  const textLength = length ?? 120;
  const cropText = (text) => `${text?.slice(0, textLength - 1)}...`;
  return (
    <div>
      {text?.toString().length > textLength
        ? (
          <div>
            <span>{cropText(text)}</span>
            <div className="mt-2" style={{ color: '#467BE3', cursor: 'pointer' }} onClick={onClick}>Подробнее</div>
          </div>
        )
        : <span>{text}</span>}
    </div>
  );
}

export default SlicedTableColumn;
